/**
 * AnnouncementService
 * Service for managing announcements with views support
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement CRUD operations with view support
 */
export class AnnouncementService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all announcement views (list view with enriched data)
     * GET /api/announcements/views
     * @returns Array of announcement model views
     */
    async getViews() {
        const response = await this.getViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all announcement views (raw response)
     */
    getViewsRaw() {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    /**
     * Get enriched announcement view by ID
     * GET /api/announcements/{id}/view
     * @param id - Announcement ID
     * @returns Announcement model view with enriched data
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`Announcement view not found: ${id}`);
        }
        return response.data;
    }
    /**
     * Get enriched announcement view by ID (raw response)
     * @param id - Announcement ID
     */
    getViewRaw(id) {
        const url = this.buildUrl(`${id}/view`);
        return this.http.get(url);
    }
    /**
     * Get detailed announcement view by ID (includes locations, events, media, links, tags, audiences)
     * GET /api/announcements/{id}/detail
     * @param id - Announcement ID
     * @returns Announcement detail model view with all related data
     */
    async getDetailView(id) {
        const response = await this.getDetailViewRaw(id);
        if (!response.data) {
            throw new Error(`Announcement detail view not found: ${id}`);
        }
        return response.data;
    }
    /**
     * Get detailed announcement view by ID (raw response)
     * @param id - Announcement ID
     */
    getDetailViewRaw(id) {
        const url = this.buildUrl(`${id}/detail`);
        return this.http.get(url);
    }
}
AnnouncementService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementService.BASE_PATH = 'api/announcements';
//# sourceMappingURL=AnnouncementService.js.map